import SlugViewer from 'scenes/SlugViewer'
import { isRouter } from 'services/router'
import { extractQueryParams } from 'services/url'
import { getRefererFromCtx, getRefererFromDocument } from 'services/tracking'
import { SlugViewerQuery } from 'scenes/SlugViewer/SlugViewer'
import withPreloadedQuery from 'withPreloadedQuery'
import { SlugViewer_Query$data } from '__generated__/SlugViewer_Query.graphql'
import { handleNotFound } from 'services/auth'

// NOTE: make sure this regexp is aligned with the backend API
const validSlugRegex = /^[a-zA-Z0-9-]+$/

export default withPreloadedQuery(SlugViewer, SlugViewerQuery, {
  fetchPolicy: 'store-and-network',
  variablesFromContext(ctx) {
    const params = extractQueryParams(ctx.asPath)
    // TODO: check if `token` is still being used, remove otherwise
    const token = params?.token

    let slug = token || ctx.query.slugs?.[0]
    const requestValid = Boolean(slug && validSlugRegex.test(slug))

    // Make `/careers` page be the Flexhire jobs listing
    if (slug === 'careers') slug = 'flexhire'

    const subslug = token ? null : ctx.query.slugs?.[1]

    const ref = (params?.ref || ctx?.query?.ref) as string
    const referer = isRouter(ctx) ? getRefererFromDocument() : getRefererFromCtx(ctx)

    return {
      requestValid,
      slug,
      subslug,
      ref,
      referer,
      token,
    }
  },
  async serverSidePostQuery(queryResultRaw, ctx) {
    const queryResult = queryResultRaw as { data: SlugViewer_Query$data } | undefined
    const data = queryResult?.data
    handleNotFound(Boolean(data?.resource), ctx)
  },
})
